import { useState } from 'react';
import { mockFaqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于羞羞漫画，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {mockFaqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {item.question}
                </h3>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-transform duration-300 ${
                  openIdx === idx ? 'bg-primary-100 text-primary-600 rotate-180' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIdx === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}